import React, {useState} from 'react';
import Select from "react-select";
import {useDispatch, useSelector} from "react-redux";
import {bbDictionaryOfEmailFrequencies, bbFindUserTagsByTagId} from "../../../util/bbHelpers";
import {Tooltip} from "@material-ui/core";
import ComingSoonIconSettings from "./ComingSoonIconSettings";
import {addEmailFrequencyTag, disableEmailNotifications, updateEmailFrequencyTag} from "../../../actions";

const EmailFrequencySelect = ({customer=null,}) => {

    const authUser = useSelector(({auth}) => auth.authUser);
    // const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({breachrisk})=> breachrisk);

    const isDisabled = true;
    const textColor = isDisabled ? "text-light-gray" : "";
    const emailFrequencyTags = bbFindUserTagsByTagId(authUser, 15);

    const hasTags = emailFrequencyTags && emailFrequencyTags.length > 0;
    const dispatch = useDispatch();

    const emailFrequencyArray = Object.values(bbDictionaryOfEmailFrequencies);
    emailFrequencyArray.splice(1,2)
    const options = emailFrequencyArray

    const [frequency, setFrequency] = useState(emailFrequencyTags
        && emailFrequencyTags.length > 0
        && emailFrequencyTags[0].details
        && options[emailFrequencyTags[0].details]
            ? options[emailFrequencyTags[0].details] : options[0]);

    const handleOnClick = (value) =>{
        console.log("handleClick, value equals", value)
        setFrequency(value)

        if(!hasTags){
            dispatch(addEmailFrequencyTag(authUser.user.id, value.value))

        } else if (hasTags && value.value !== 0){
            dispatch(updateEmailFrequencyTag(emailFrequencyTags[0]));
            dispatch(addEmailFrequencyTag(authUser.user.id, value.value, false));
        } else if (hasTags && value.value === 0){
            dispatch(disableEmailNotifications);
            dispatch(updateEmailFrequencyTag(emailFrequencyTags[0]));
        }

    }


    return(
            <div className={`row align-self-center ${textColor}`}>
                <Tooltip title={"Select how often you would lie to receive email notifications about activity. Select Every Time to receive an email for every item you select, or have notifications collected to be sent out daily, weekly, or monthly."}>
                    <>
                <p className={"col-5 text-right align-self-center"}>Email Frequency:</p>
                <p className={"col-1"}> </p>
                <p className={"col-6 text-left"}>
                        <Select
                            className={"col-6 m-0 p-0"}
                            name={"frequency"}
                            options={options}
                            value={frequency}
                            onChange={(value)=>handleOnClick(value)}>
                        </Select>
                </p>
                        </>
                </Tooltip>
                {isDisabled && <ComingSoonIconSettings className={"align-self-center mt-1 pt-1"}/>}

            </div>
    )
}

export default EmailFrequencySelect;